import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import RadarGradeChart from "./RadarGradeChart";
import PieGradeChart from "./PieGradeChart";
import { testNameList } from "./config";

const useStyles = makeStyles(theme => ({
  root: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1)
  },
  divider: {
    marginBottom: theme.spacing(1),
    color: theme.palette.primary.light
  },
  typography: {
    marginTop: theme.spacing(4)
  },
  paper: {
    width: "95%",
    padding: theme.spacing(1),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    marginRight: theme.spacing(2)
  },
  chart: {
    margin: "auto"
  },
  dialog: {
    width: "100%"
  }
}));
//get basic state for a Dialog
function useDialog() {
  const [open, setOpen] = useState(false);

  function handleClickOpen() {
    setOpen(true);
  }

  function handleClose() {
    setOpen(false);
  }
  return [open, handleClickOpen, handleClose];
}

//获取各实验平均成绩
function getAverageGrade(grades) {
  const AverageGrade = {};
  testNameList.forEach(testName => {
    const gradeForThisTest = grades.filter(
      grade => grade.test_type === testName
    );
    let gradeSum = 0,
      avgGradeForTest;
    if (gradeForThisTest.length > 0) {
      gradeForThisTest.forEach(gradeNow => {
        gradeSum += gradeNow.grade;
      });
      avgGradeForTest = (gradeSum / gradeForThisTest.length).toFixed(0);
    } else {
      avgGradeForTest = 0;
    }
    AverageGrade[testName] = Number(avgGradeForTest);
  });
  return AverageGrade;
}

//根据用户id filter
function gradeIdFilter(grades, userId) {
  return grades.filter(grade => {
    return grade.user === userId;
  });
}

//Main Component
function StudentGradeDetailDialogButton(props) {
  const classes = useStyles();

  const [open, handleClickOpen, handleClose] = useDialog();

  const { buttonText, grades, UserId, averageGrade } = props;

  return (
    <>
      <Button onClick={handleClickOpen} color="secondary" component="span">
        {buttonText}
      </Button>

      <Dialog open={open} onClose={handleClose} className={classes.dialog}>
        <DialogContent className={classes.dialog}>
          <Grid
            container
            component={Paper}
            className={classes.paper}
            justify="center"
          >
            <Typography
              variant="h5"
              gutterBottom
              color="secondary"
              className={classes.typography}
            >
              {buttonText}实验成绩雷达图
            </Typography>
            <Grid item xs={12}>
              <RadarGradeChart
                gradeData={gradeIdFilter(grades, UserId)}
                averageGrade={getAverageGrade(gradeIdFilter(grades, UserId))}
              />
            </Grid>
            <Typography
              variant="h5"
              gutterBottom
              color="secondary"
              className={classes.typography}
            >
              {buttonText}实验完成次数图
            </Typography>
            <Grid item xs={12}>
              <PieGradeChart gradeData={gradeIdFilter(grades, UserId)} />
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default StudentGradeDetailDialogButton;
